import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export function useClientLookup() {
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ["client"],
        queryFn: async ({ signal }) => {
            try {
                const { data } = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api-admin/v2/client`,
                    { withCredentials: true, signal }
                );
                return data?.data ?? [];
            } catch (error) {
                if (error?.response?.status === 401) {
                    queryClient.invalidateQueries({ queryKey: ["session-lookup"] });
                }
                throw (error?.response?.data ?? error);
            }
        },
        initialData: [],
        retry: false,
    });
}
